<script setup lang="ts">
import {useDevelopersCode} from "~/stores/useDevelopersCode";

const { t } = useI18n();
const { currentTab, currentLang, setTab, setLang, setContent } = useDevelopersCode();

const langs = [
  { name: 'c-sharp', img: 'c-sharp.svg' },
  { name: 'go', img: 'go.svg' },
  { name: 'java', img: 'java.svg' },
  { name: 'nodejs', img: 'nodejs.svg' },
  { name: 'php', img: 'php.svg' },
  { name: 'python', img: 'python.svg' },
];

const tabs = [
  { type: 'create', nameKey: 'pages.developers.tabs.create' },
  { type: 'check', nameKey: 'pages.developers.tabs.check' },
  { type: 'update', nameKey: 'pages.developers.tabs.update' },
  { type: 'info', nameKey: 'pages.developers.tabs.info' },
];

const setCurrentLang = (lang: string) => {
  setLang(lang);
  setContent();
};

const setCurrentTab = (tab: string) => {
  setTab(tab);
  setContent();
};
</script>

<template>
  <div class="code-lang-switch">
    <div class="code-lang-switch__list">
      <div v-for="(item, index) in langs" :key="index" class="code-lang-switch__item">
        <div
          class="code-lang-switch__item-inner"
          :class="{ 'code-lang-switch__item-inner--active': currentLang === item.name }"
          @click="setCurrentLang(item.name)"
        >
          <!--          <NuxtImg :src="`/codeLangs/${item.img}`" alt="code_lang" class="code-lang-switch__img" />-->
          <img :src="`/codeLangs/${item.img}`" :alt="`code_lang-${item.name}`" class="code-lang-switch__img"  />
        </div>
      </div>
    </div>

    <div class="code-lang-switch__sublist">
      <div
        v-for="(tab, index) in tabs"
        :key="index"
        class="code-lang-switch__tab"
        :class="{ 'code-lang-switch__tab--active': currentTab === tab.type }"
        @click="setCurrentTab(tab.type)"
      >
        {{ t(tab.nameKey) }}
      </div>
    </div>
  </div>
</template>

<style scoped lang="scss">
.code-lang-switch {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 16px;

  &__list {
    background: rgba(238, 238, 238, 0.5);
    display: flex;
    justify-content: space-between;
    height: 56px;
    padding: 4px;
    border-radius: 52px;
    width: 100%;
    max-width: 992px;
  }

  &__sublist {
    background: rgba(238, 238, 238, 0.5);
    display: flex;
    justify-content: space-between;
    height: 52px;
    padding: 4px;
    border-radius: 52px;
    align-items: center;
    max-width: 565px;
    width: 100%;
    @media (max-width: 600px) {
      height: auto;
      flex-wrap: wrap;
      border-radius: 12px;
    }
  }

  &__tab {
    width: calc(100% / 4);
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    border-radius: 44px;
    @media (max-width: 600px) {
      height: auto;
      width: 50%;
      padding: 4px 8px;
      flex-wrap: wrap;
      border-radius: 8px;
    }

    &--active {
      background: #fff !important;
    }

    &:hover {
      background: #efefef;
    }
  }

  &__item {
    width: calc(100% / 6);
    display: flex;
    align-items: center;
    justify-content: center;
    margin: 8px 0;
    padding: 0 12px;
    cursor: pointer;

    &:last-child {
      padding-right: 0 !important;
    }
    &:first-child {
      padding-left: 0 !important;
    }

    &-inner {
      width: 100%;
      display: flex;
      align-items: center;
      justify-content: center;
      border-radius: 44px;
      height: 48px;

      &--active {
        background: #fff !important;
      }

      &:hover {
        background: #efefef;
      }
    }

    &:not(:last-child) {
      border-right: 1px solid #E1E1E1;
    }
  }

  &__img {
    width: 100%;
    object-fit: scale-down;
  }
}
</style>
